import { createFileRoute } from "@tanstack/react-router";
import { About } from "@/features/settings/about";

export const Route = createFileRoute("/settings/about")({
  component: About,
});
